/*
  NINI Artikel-Vorlagen 2026 – kleines Progressive-Enhancement-Script ohne
  Abhängigkeiten für sections/nini-article.liquid:

  1. Inhaltsverzeichnis: sammelt die h2 im Fließtext-Block, vergibt eindeutige
     IDs und baut daraus Sprungmarken. Weniger als zwei Überschriften -> der
     TOC-Block bleibt ausgeblendet.
  2. Tabellen: jede <table> im Fließtext bekommt einen horizontal scrollbaren
     Wrapper inkl. Scroll-Hinweis, damit mobil nichts über die Seite hinausläuft.
  3. "Link kopieren": Clipboard-API mit Fallback, Button-Text wechselt kurz.

  Kein alert()/confirm(), alle Zugriffe defensiv – das Script darf auf Artikeln
  ohne die jeweiligen Bausteine nichts tun und nichts werfen.
*/

(function () {
  'use strict';

  var COPY_RESET_MS = 2000;

  function slugify(value) {
    var text = String(value || '')
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss');

    if (typeof text.normalize === 'function') {
      text = text.normalize('NFD').replace(/[̀-ͯ]/g, '');
    }

    return text.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function buildToc(root) {
    var toc = root.querySelector('[data-nini-toc]');
    var list = toc && toc.querySelector('[data-nini-toc-list]');
    var content = root.querySelector('[data-nini-content]');

    if (!toc || !list || !content) return;

    list.textContent = '';
    toc.hidden = true;

    var headings = content.querySelectorAll('h2');
    if (headings.length < 2) return;

    var used = {};
    var fragment = document.createDocumentFragment();
    var added = 0;

    Array.prototype.forEach.call(headings, function (heading) {
      var label = (heading.textContent || '').trim();
      if (!label) return;

      var id = heading.id;
      if (!id) {
        var base = slugify(label) || 'abschnitt';
        id = 'nini-' + base;
        var suffix = 2;
        while (used[id] || document.getElementById(id)) {
          id = 'nini-' + base + '-' + suffix;
          suffix += 1;
        }
        heading.id = id;
      }
      used[id] = true;

      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + id;
      link.textContent = label;
      item.appendChild(link);
      fragment.appendChild(item);
      added += 1;
    });

    if (added < 2) return;

    list.appendChild(fragment);
    toc.hidden = false;
  }

  function wrapTables(root) {
    var content = root.querySelector('[data-nini-content]');
    if (!content) return;

    var tables = content.querySelectorAll('table');
    Array.prototype.forEach.call(tables, function (table) {
      var parent = table.parentNode;
      if (!parent) return;
      if (parent.classList && parent.classList.contains('nini-article__table-wrap')) return;

      var wrap = document.createElement('div');
      wrap.className = 'nini-article__table-wrap';
      parent.insertBefore(wrap, table);
      wrap.appendChild(table);

      var markOverflow = function () {
        if (wrap.scrollWidth - wrap.clientWidth > 2) {
          wrap.classList.add('nini-article__table-wrap--overflow');
        } else {
          wrap.classList.remove('nini-article__table-wrap--overflow');
        }
      };

      markOverflow();
      if (typeof ResizeObserver === 'function') {
        try {
          new ResizeObserver(markOverflow).observe(wrap);
        } catch (error) {
          void error;
        }
      } else {
        window.addEventListener('resize', markOverflow);
      }
    });
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      try {
        var field = document.createElement('textarea');
        field.value = text;
        field.setAttribute('readonly', 'readonly');
        field.style.position = 'fixed';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(field);
        if (ok) {
          resolve();
        } else {
          reject(new Error('copy-failed'));
        }
      } catch (error) {
        reject(error);
      }
    });
  }

  function initCopyButtons(root) {
    var buttons = root.querySelectorAll('[data-nini-copy]');

    Array.prototype.forEach.call(buttons, function (button) {
      if (button.dataset.niniCopyReady === 'true') return;
      button.dataset.niniCopyReady = 'true';

      var labelNode = button.querySelector('[data-nini-copy-label]') || button;
      var originalLabel = labelNode.textContent;
      var copiedLabel = button.getAttribute('data-nini-label-copied') || 'Copied';
      var timer = null;

      button.addEventListener('click', function () {
        var url = button.getAttribute('data-nini-url') || window.location.href;

        copyText(url)
          .then(function () {
            labelNode.textContent = copiedLabel;
            button.setAttribute('data-nini-copied', 'true');
            window.clearTimeout(timer);
            timer = window.setTimeout(function () {
              labelNode.textContent = originalLabel;
              button.removeAttribute('data-nini-copied');
            }, COPY_RESET_MS);
          })
          .catch(function () {
            /* Zwischenablage nicht verfügbar – Button bleibt unverändert. */
          });
      });
    });
  }

  function init() {
    var roots = document.querySelectorAll('[data-nini-article]');
    Array.prototype.forEach.call(roots, function (root) {
      try {
        buildToc(root);
        wrapTables(root);
        initCopyButtons(root);
      } catch (error) {
        void error;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var target = event && event.target;
    if (!target || !target.querySelectorAll) return;
    try {
      var roots = target.querySelectorAll('[data-nini-article]');
      Array.prototype.forEach.call(roots, function (root) {
        buildToc(root);
        wrapTables(root);
        initCopyButtons(root);
      });
    } catch (error) {
      void error;
    }
  });
})();
